import React, {ReactNode} from 'react';
import Breadcrumb from './Breadcrumb';
import './CommonLayout.scss';


interface CommonLayoutProps {
  children: ReactNode;
  maxWidth?: string; // optional
}

const CommonLayout: React.FC<CommonLayoutProps> = ({ children, maxWidth }) => {
  const layoutStyle = {
    maxWidth: maxWidth || '1000px', // Default to 1000px if not provided
  };

  return (
    <div className="common-layout-root">
      <Breadcrumb />
      <div className="common-layout" style={layoutStyle}>
        {children}
      </div>
    </div>
  );
};

export default CommonLayout;
